import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const indicatorDefaultVariants = {
  "size": "sm",
  "variant": "primary"
}
const indicatorCompoundVariants = []

const indicatorSlotNames = [
  [
    "root",
    "Indicator__root"
  ],
  [
    "icon",
    "Indicator__icon"
  ]
]
const indicatorSlotFns = /* @__PURE__ */ indicatorSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, indicatorDefaultVariants, getSlotCompoundVariant(indicatorCompoundVariants, slotName))])

const indicatorFn = memo((props = {}) => {
  return Object.fromEntries(indicatorSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const indicatorVariantKeys = [
  "size",
  "variant"
]
const getVariantProps = (variants) => ({ ...indicatorDefaultVariants, ...compact(variants) })

export const indicator = /* @__PURE__ */ Object.assign(indicatorFn, {
  __recipe__: false,
  __name__: 'indicator',
  raw: (props) => props,
  variantKeys: indicatorVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ],
  "variant": [
    "neutral",
    "primary",
    "warning",
    "danger",
    "success",
    "info"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, indicatorVariantKeys)
  },
  getVariantProps
})